export default __webpack_public_path__ + "static/media/lease_single.72ca190c.svg";